var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopilotStudio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.3242 4.77449C52.3121 0.77044 46.3052 -1.23042 42.1523 1.76277C38.0001 4.75619 38 11.0874 38 23.7491V33.9991L28.3242 30.7745C16.3121 26.7705 10.3052 24.7696 6.15234 27.7628C1.99998 30.7562 2 37.0874 2 49.7491V67.585C2 74.5417 1.9996 78.0209 3.88672 80.6397C5.7743 83.2586 9.07559 84.3596 15.6758 86.5596L20.002 87.9991L20 88.0011L33.8906 92.63C41.0527 95.0173 44.634 96.2117 48.2168 95.6612C51.7998 95.1105 54.8577 92.8959 60.9727 88.4678L79.5957 74.9835C84.6242 71.3421 87.5709 69.2032 89.3691 66.7569C89.551 66.5194 89.7213 66.2697 89.8789 66.005C90.0501 65.7303 90.212 65.4518 90.3594 65.1632C91.9996 61.9502 92 58.1948 92 50.6846V28.4151C92 21.4583 92.0007 17.9792 90.1133 15.3604C88.2257 12.7416 84.9244 11.6425 78.3242 9.44246L64.3242 4.77449Z",
    fill: "url(#paint0_linear_4303_1230)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3242 4.77449C52.3121 0.77044 46.3052 -1.23042 42.1523 1.76277C38.0001 4.75619 38 11.0874 38 23.7491V33.9991L28.3242 30.7745C16.3121 26.7705 10.3052 24.7696 6.15234 27.7628C1.99998 30.7562 2 37.0874 2 49.7491V67.585C2 74.5417 1.9996 78.0209 3.88672 80.6397C5.7743 83.2586 9.07559 84.3596 15.6758 86.5596L20.002 87.9991L20 88.0011L33.8906 92.63C41.0527 95.0173 44.634 96.2117 48.2168 95.6612C51.7998 95.1105 54.8577 92.8959 60.9727 88.4678L79.5957 74.9835C84.6242 71.3421 87.5709 69.2032 89.3691 66.7569C89.551 66.5194 89.7213 66.2697 89.8789 66.005C90.0501 65.7303 90.212 65.4518 90.3594 65.1632C91.9996 61.9502 92 58.1948 92 50.6846V28.4151C92 21.4583 92.0007 17.9792 90.1133 15.3604C88.2257 12.7416 84.9244 11.6425 78.3242 9.44246L64.3242 4.77449Z",
    fill: "url(#paint1_radial_4303_1230)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3242 4.77449C52.3121 0.77044 46.3052 -1.23042 42.1523 1.76277C38.0001 4.75619 38 11.0874 38 23.7491V33.9991L28.3242 30.7745C16.3121 26.7705 10.3052 24.7696 6.15234 27.7628C1.99998 30.7562 2 37.0874 2 49.7491V67.585C2 74.5417 1.9996 78.0209 3.88672 80.6397C5.7743 83.2586 9.07559 84.3596 15.6758 86.5596L20.002 87.9991L20 88.0011L33.8906 92.63C41.0527 95.0173 44.634 96.2117 48.2168 95.6612C51.7998 95.1105 54.8577 92.8959 60.9727 88.4678L79.5957 74.9835C84.6242 71.3421 87.5709 69.2032 89.3691 66.7569C89.551 66.5194 89.7213 66.2697 89.8789 66.005C90.0501 65.7303 90.212 65.4518 90.3594 65.1632C91.9996 61.9502 92 58.1948 92 50.6846V28.4151C92 21.4583 92.0007 17.9792 90.1133 15.3604C88.2257 12.7416 84.9244 11.6425 78.3242 9.44246L64.3242 4.77449Z",
    fill: "url(#paint2_radial_4303_1230)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56 54.4151C56 47.4579 56 43.9793 54.1124 41.3604C52.2248 38.7415 48.9247 37.6415 42.3246 35.4414L28.3246 30.7748C16.312 26.7706 10.3058 24.7685 6.1529 27.7617C2 30.755 2 37.0861 2 49.7484V67.5847C2 74.5419 2 78.0206 3.88758 80.6394C5.77516 83.2583 9.07525 84.3583 15.6754 86.5584L29.6754 91.2251C41.688 95.2292 47.6942 97.2313 51.8471 94.2381C56 91.2448 56 84.9137 56 72.2514V54.4151Z",
    fill: "url(#paint3_radial_4303_1230)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56 54.4151C56 47.4579 56 43.9793 54.1124 41.3604C52.2248 38.7415 48.9247 37.6415 42.3246 35.4414L28.3246 30.7748C16.312 26.7706 10.3058 24.7685 6.1529 27.7617C2 30.755 2 37.0861 2 49.7484V67.5847C2 74.5419 2 78.0206 3.88758 80.6394C5.77516 83.2583 9.07525 84.3583 15.6754 86.5584L29.6754 91.2251C41.688 95.2292 47.6942 97.2313 51.8471 94.2381C56 91.2448 56 84.9137 56 72.2514V54.4151Z",
    fill: "url(#paint4_linear_4303_1230)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92 50.6846C92 58.1947 91.9996 61.9501 90.3594 65.1631C90.212 65.4517 90.0501 65.7302 89.8789 66.0049C89.7213 66.2696 89.551 66.5193 89.3691 66.7568C87.5709 69.2031 84.6242 71.3421 79.5957 74.9834L60.9727 88.4678C54.8577 92.8959 51.7998 95.1105 48.2168 95.6611C44.634 96.2116 41.0527 95.0172 33.8906 92.6299L25.2158 89.7393L20 88L20.002 87.999L16.7822 86.9277L15.2217 86.4072C8.92337 84.3067 5.73047 83.1977 3.88672 80.6396C1.99964 78.0208 2 74.5416 2 67.585V49.749C2 48.4323 2.00119 47.1841 2.00586 46.001L56 61.501L92 35.001V50.6846Z",
    fill: "url(#paint5_radial_4303_1230)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0742 15.1036C31.3033 13.0668 27.2217 12.5497 24.1523 14.7618C21.0793 16.9767 20.281 21.0195 20.0732 28.1026C22.4635 28.8216 25.1889 29.7306 28.3232 30.7754L37.999 34V23.7491C37.999 20.4569 38.0012 17.5925 38.0742 15.1036Z",
    fill: "url(#paint6_linear_4303_1230)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0742 15.1036C31.3033 13.0668 27.2217 12.5497 24.1523 14.7618C21.0793 16.9767 20.281 21.0195 20.0732 28.1026C22.4635 28.8216 25.1889 29.7306 28.3232 30.7754L37.999 34V23.7491C37.999 20.4569 38.0012 17.5925 38.0742 15.1036Z",
    fill: "url(#paint7_linear_4303_1230)",
    fillOpacity: 0.7
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0742 15.1035C38.0012 17.5922 38 20.4561 38 23.748V41.585C38 48.5419 38.0002 52.0208 39.8877 54.6396C41.7753 57.2583 45.0758 58.3586 51.6758 60.5586L56 62C64.0027 64.6676 68.0041 66.0014 70.84 64.1408C71.0112 64.0284 71.1774 63.9086 71.3381 63.7817C74 61.6798 74 57.462 74 49.0263V41.415C74 34.4579 73.9999 30.9792 72.1123 28.3604C70.2247 25.7416 66.9243 24.6414 60.3242 22.4414L46.3242 17.7744C43.1901 16.7297 40.4644 15.8225 38.0742 15.1035Z",
    fill: "url(#paint8_linear_4303_1230)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0742 15.1035C38.0012 17.5922 38 20.4561 38 23.748V41.585C38 48.5419 38.0002 52.0208 39.8877 54.6396C41.7753 57.2583 45.0758 58.3586 51.6758 60.5586L56 62C64.0027 64.6676 68.0041 66.0014 70.84 64.1408C71.0112 64.0284 71.1774 63.9086 71.3381 63.7817C74 61.6798 74 57.462 74 49.0263V41.415C74 34.4579 73.9999 30.9792 72.1123 28.3604C70.2247 25.7416 66.9243 24.6414 60.3242 22.4414L46.3242 17.7744C43.1901 16.7297 40.4644 15.8225 38.0742 15.1035Z",
    fill: "url(#paint9_radial_4303_1230)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0742 28.1035C20.0012 30.5922 20 33.4561 20 36.748V54.585C20 61.5421 20.0001 65.0208 21.8877 67.6396C23.7753 70.2584 27.0757 71.3586 33.6758 73.5586L37.975 74.9917C46.0014 77.6671 50.0146 79.0049 52.855 77.1309C53.0159 77.0247 53.1724 76.9119 53.324 76.7928C56 74.6909 56 70.4606 56 62V54.415C56 47.4579 55.9999 43.9792 54.1123 41.3604C52.2247 38.7416 48.9243 37.6414 42.3242 35.4414L28.3242 30.7744C25.1901 29.7297 22.4644 28.8225 20.0742 28.1035Z",
    fill: "url(#paint10_linear_4303_1230)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38 41.585C38 48.5422 38.0001 52.0208 39.8877 54.6397C41.7753 57.2585 45.0756 58.3585 51.6758 60.5586L56 62V54.415C56 47.4581 55.9998 43.9792 54.1123 41.3604C52.2247 38.7417 48.9242 37.6414 42.3242 35.4414L38 34V41.585Z",
    fill: "url(#paint11_linear_4303_1230)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4303_1230",
    x1: 53.5,
    y1: 77,
    x2: 80.9999,
    y2: 9.99998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2764E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307475,
    stopColor: "#8B52F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544627,
    stopColor: "#BB45EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803866,
    stopColor: "#DB56C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F462AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4303_1230",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.5 45) rotate(43.8065) scale(33.9485 21.4653)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.549399,
    stopColor: "#5B2AB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A931D8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4303_1230",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44 34) rotate(17.7004) scale(49.3356 24.5964)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.527929,
    stopColor: "#9529C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD3CE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4303_1230",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.3922 89.3373) rotate(-124.89) scale(82.0935 82.0935)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2764E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225228,
    stopColor: "#0094F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443437,
    stopColor: "#19B2CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6999,
    stopColor: "#52D17C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD638"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4303_1230",
    x1: 19.5444,
    y1: 82.7096,
    x2: 53.8452,
    y2: 82.7096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16BBDA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535279,
    stopColor: "#0094F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2764E7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_4303_1230",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(23 12.9998 8.90874 -13.0499 43 67.9995)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B44B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367AF2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4303_1230",
    x1: 33.5,
    y1: 32.5,
    x2: 34,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4303_1230",
    x1: 28.5,
    y1: 24.5,
    x2: 26.5,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB357",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F24A9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4303_1230",
    x1: 58,
    y1: 20,
    x2: 58.5,
    y2: 64.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.380259,
    stopColor: "#FB6F7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659779,
    stopColor: "#F24A9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD3CE2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_4303_1230",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40 54) rotate(12.702) scale(24.0895 24.0895)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.567938,
    stopColor: "#D7257D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F462AB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4303_1230",
    x1: 50.03,
    y1: 77.3707,
    x2: 20,
    y2: 25.6869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FAFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54828,
    stopColor: "#2BDABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765945,
    stopColor: "#88E06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD638"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4303_1230",
    x1: 36,
    y1: 44.5,
    x2: 53,
    y2: 50.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76EB95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BD5FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopilotStudio);
export default __webpack_public_path__ + "static/media/copilot-studio.3f7de922591d832fa78be741d484c2d3.svg";
export { ForwardRef as ReactComponent };